/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ProductPagedDto } from '../models/product-paged-dto';
import { SegmentEnum } from '../models/segment-enum';

@Injectable({
  providedIn: 'root',
})
export class ProductService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation searchProductsPaged
   */
  static readonly SearchProductsPagedPath = '/products/search';

  /**
   * Search for products.
   *
   * Either search or categoryId is required
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchProductsPaged()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchProductsPaged$Response(params?: {
    search?: string;
    categoryId?: string;
    segment?: Array<SegmentEnum>;
    page?: number;
    size?: number;
  }): Observable<StrictHttpResponse<ProductPagedDto>> {

    const rb = new RequestBuilder(this.rootUrl, ProductService.SearchProductsPagedPath, 'post');
    if (params) {
      rb.query('search', params.search, {});
      rb.query('categoryId', params.categoryId, {});
      rb.query('segment', params.segment, {});
      rb.query('page', params.page, {});
      rb.query('size', params.size, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductPagedDto>;
      })
    );
  }

  /**
   * Search for products.
   *
   * Either search or categoryId is required
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `searchProductsPaged$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchProductsPaged(params?: {
    search?: string;
    categoryId?: string;
    segment?: Array<SegmentEnum>;
    page?: number;
    size?: number;
  }): Observable<ProductPagedDto> {

    return this.searchProductsPaged$Response(params).pipe(
      map((r: StrictHttpResponse<ProductPagedDto>) => r.body as ProductPagedDto)
    );
  }

}
